export const getType = (obj) => {
  const lowerCaseTheFirstLetter = (str) => str[0].toLowerCase() + str.slice(1);
  const type = typeof obj;
  if (type !== 'object') {
    return type;
  }
  return lowerCaseTheFirstLetter(
    Object.prototype.toString.call(obj).replace(/^\[object (\S+)\]$/, '$1')
  );
}

export const capitalize = (string) => {
  if(typeof string !== 'string') {
    return string;
  }
  return string.toLowerCase().charAt(0).toUpperCase() + string.slice(1);
}

export const keysValues = obj => {
  if(getType(obj) !== 'object'){
    throw Error('expects a object argument');
  }
  return Object.entries(obj).map(([key, value]) => ({key, value}))

}


export const handlerError = (err) => {
  console.error(err);
  throw err;
};


export const reorder = (list, startIndex, endIndex) => {
  console.log(startIndex, endIndex)
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getContactInformation = () => {
  let contact = {};
  if(window.region === "SG") {
    contact = {
      email: "hello@frameit.com.sg",
      phone: "+65 8798 6867",
    }
  } else if (window.region === "MY") {
    contact = {
      email: "hello@frameit.my",
      phone: "+65 8798 6867",
    }
  }

  return contact
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}


export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getAwsS3ImageUrl = (type, name) => `https://s3-ap-southeast-1.amazonaws.com/frameitsg/${type}/${name}`


// WEBPACK FOOTER //
// ./src/helpers/index.js